module.exports = __webpack_public_path__ + "f893b0e74f4e8aaa61c3c3d687ddde34.svg";